import { push } from 'redux-first-history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/otp.svg';
import LogoutStyled from '../shared/LogoutStyled';
import * as actions from '../../actions';
import MoreOptions from '../shared/MoreOptions';
import RememberMe from '../shared/RememberMe';

/**
 * Otp Component
 */
export class Otp extends Component {
  state = { tokenCode: '', };
  /**
   * The allowed properties for the Otp component
   * @param {function} verifyOtp verification the token code
   * @param {bool} isLoading is something on the page loading?
   * @param {string} challengeText instructions returned from the server for the user when entering the OTP token
   * @param {array} availableModalities available modalities to switch to
   */

  static propTypes = {
    verifyOtp: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    challengeText: PropTypes.string,
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };

  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    useCustomUX: false,
  };

  handleInputChange = data => {
    this.setState({ tokenCode: data.tokenCode, });
  };

  submitForm = data => {
    this.props.verifyOtp(data.tokenCode);
    this.setState({ tokenCode: '', });
  };

  render() {
    const {
      availableModalities,
      challengeText,
      isLoading,
      serverState,
      sessionService,
      tokenCode,
      useCustomUX,
      username,
      allowEditUsername,
    } = this.props;

    let moreOptions = null;
    let moreOptionsMarkup = <MoreOptions currentModality='otp' />;
    let moreOptionsAltMarkup = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'otp') : [];
    const modalitiesArePresent = modalities.length > 0;

    const hasTempCodeMessage = serverState && serverState.temporaryCodeAllowed && !serverState.temporaryCodeAvailable;

    modalitiesArePresent && (moreOptions = moreOptionsMarkup);
    (hasTempCodeMessage && !modalitiesArePresent) && (moreOptions = moreOptionsAltMarkup);

    const isCidMobile = (sessionService === 'cidmobile');
    const headerDescription = isCidMobile ? 'Enter hard token' : 'Enter hard or soft token';
    const submitText = isCidMobile ? 'Continue' : 'Confirm your identity';
    const logoutStyle = useCustomUX ? 'black' : 'white';
    const logoutComponent = !isCidMobile ? <LogoutStyled type={logoutStyle} /> : null;


    return (
      <div className='content-body'>
        <SingleInput
          headerImage={headerImage}
          headerTitle='Token code'
          headerDescription={headerDescription}
          placeholderText='Token code'
          submitText={submitText}
          onSubmit={this.submitForm}
          retryText=''
          inputType='password'
          isLoading={isLoading}
          autoFocus={true}
          moreOptionsLink={moreOptions}
          onInputChange={data => this.handleInputChange(data)}
          tokenCode={tokenCode}
          logoutComponent={logoutComponent}
          footer={<RememberMe />}
          cidMobile={isCidMobile}
          useCustomUX={useCustomUX}
          username={isCidMobile ? null : username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        >
          {challengeText}
        </SingleInput>
      </div>
    );
  };
};


const mapStateToProps = state => {
  const {
    isLoading, challengeText, availableModalities, serverState, isDeviceManagementWorkflow, sessionService, useCustomUX,
    username, isClinicalWorkflow, allowEditUsername,
  } = state.login;
  return {
    isLoading,
    challengeText,
    availableModalities,
    serverState,
    isDeviceManagementWorkflow,
    sessionService,
    useCustomUX,
    username,
    allowEditUsername,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyOtp: tokenCode => {
      dispatch(actions.verifyOtp(tokenCode) );
    },
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Otp);
